import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { palette, spaces } from '../../../assets/styles/themes/tokens';

const CourseFinishPageLoader = () => {
	const { t } = useTranslation();
	return (
		<Stack gap={spaces.xl} height="100%" justifyContent="center" alignItems="center">
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					paddingTop: spaces.xxxl,
					width: '100%',
				}}
				data-testid="course-finish-page-loader"
			>
				<CircularProgress
					sx={{
						'& .MuiCircularProgress-svg': {
							height: 'auto',
							width: 'auto',
						},
					}}
					size={60}
				/>
			</Box>
			<Stack gap={spaces.xs} maxWidth={448}>
				<Typography variant="h5" color={palette.text.primary} textAlign="center">
					{t('Your certificate will be created')}
				</Typography>
				<Typography variant="subtitle1" color={palette.text.secondary} textAlign="center">
					{t('It only takes a moment.')}
				</Typography>
			</Stack>
		</Stack>
	);
};
export default CourseFinishPageLoader;
